// extracted by mini-css-extract-plugin
module.exports = {"radioBtn":"ReverseNumberingExtended_radioBtn__2jJ_j","radioBtnWrapper":"ReverseNumberingExtended_radioBtnWrapper__3eNeM"};